(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["blogs"] && !window.DesignMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('blogs', ( data ) => ({
			blog_path: data.blog_path,
			pagination_type: data.pagination_type,
			blog: [],
			page: 1, 
			loading: false,
			init() {	
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					this.page = parseInt(query_parms.get('page'));
					if(this.page > 1 && this.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
						location.href = this.blog_path;
					}
				}
			},
			get_blogs( concat = false, page = 1){
				var self = this;
				var request_url = self.blog_path + '?page=' + page;
				// var request_url = '/blogs/{{ blog.handle }}?page=' + page;
				self.loading = true; 
				self.page = page;
				if( concat == false ){
					self.blog = [];
				}
				fetch(request_url).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', request_url);
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var container = doc.getElementById('ajax_blogs_container');
					if(container){
						var data = container.getAttribute('x-init');
						if( data.startsWith( 'blog=' ) ){ 
							data = JSON.parse( data.substring( 5 ) );
							self.blog = self.blog.concat(data);
						} else {
							console.error( 'section/blogs.liqud: ==>> #ajax_blogs_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/blogs.liqud  ==>> #ajax_blogs_container missing' );
					}
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			}

		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !window.DesignMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('collection_products', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			products: [],
			page: 1, 
			loading: false,
			filters: [],
			price_gte: '',
			price_lte: '',
			html: '',
			pagination: '',
			all_products_count: false,
			mobile_filter_menu: false,
			sort_menu: false,
			sort_by: data.sort_by,
			init() {
				var self = this;
				var refresh_products = false;
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					var query = query_str.split('&');
					query.forEach(function(term){
						if(term.startsWith('sort_by')){
							self.sort_by = query_parms.get('sort_by');
						}
						if(term.startsWith('page=')){
							self.page = parseInt(query_parms.get('page'));
							if(self.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
								location.href = window.location.href.replace('?page='+ self.page +'&', '?' ).replace( '?page='+ self.page, '?' );
							}
						} else if(term.startsWith('filter.v.price')){
							if(query_parms.get('filter.v.price.gte') > 0){
								self.price_gte = query_parms.get('filter.v.price.gte');
							}
							if(query_parms.get('filter.v.price.lte') > 0){
								self.price_lte = query_parms.get('filter.v.price.lte');
							}
						} else {
							self.filters.push(term);
						}
					});
				}
				this.$watch('filters', (value) => this.get_products());
				this.$watch('sort_by', (value) => this.get_products());
			},
			get_products( concat = false, page = 1){
				var self = this;
				self.loading = true;
				self.sort_menu = false;
				self.page = page;
				var query_str = (self.page > 1 || self.filters.length > 0 || self.price_gte > 0 || self.price_lte > 0 || self.sort_by) ? '?' : '';
				query_str += self.page > 1 ? 'page=' + self.page : ''; // query page #
				query_str += (query_str != '?' && self.price_gte > 0) ? '&' : '';
				query_str += (self.price_gte > 0) ? 'filter.v.price.gte=' + self.price_gte : ''; // query min-price
				query_str += (query_str != '?' && self.price_lte > 0) ? '&' : '';
				query_str += (self.price_lte > 0) ? 'filter.v.price.lte=' + self.price_lte : ''; // query max-price
				query_str += (query_str != '?' && self.filters.length > 0) ? '&' : '';
				query_str += self.filters.length > 0 ? self.filters.join('&') : ''; // query filters
				query_str += (query_str != '?' && self.sort_by) ? '&' : '';
				query_str += (self.sort_by) ? 'sort_by=' + self.sort_by : ''; // query sorting
				if( concat == false ){
					self.products = [];
				}
				fetch(self.collection_path + query_str).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', self.collection_path + query_str );
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var product_container = doc.getElementById('ajax_products_container');
					if(product_container){
						var data = product_container.getAttribute('x-init')
						if( data.startsWith( 'products=' ) ){ 
							data = JSON.parse( data.substring( 9 ) );
							self.products = self.products.concat(data);
							console.log(self.products);
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_products_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_products_container missing' );
					}
					var all_products_count = doc.getElementById('ajax_all_products_count');
					if(all_products_count){
						var data = all_products_count.getAttribute('x-init');
						if( data.startsWith( 'all_products_count=' ) ){ 
							var count = JSON.parse( data.substring( 19 ) );
							self.all_products_count = count;
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_all_products_count x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_all_products_count missing' );
					}
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			},
			clear_query(){
				this.page = 1;
				this.filters = [];
				this.price_gte = '';
				this.price_lte = '';
			}
		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-list"] && !window.DesignMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('collections_list', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			collections: [],
			page: 1, 
			loading: false,
			init() {	
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					this.page = parseInt(query_parms.get('page'));
					if(this.page > 1 && this.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
						location.href = this.collection_path;
					}
				}
			},
			get_collections( concat = false, page = 1){
				var self = this;
				self.loading = true; 
				self.page = page;
				if( concat == false ){
					self.collections = [];
				}
				fetch(self.collection_path + '?page=' + page).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', self.collection_path + '?page=' + page );
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var collections_container = doc.getElementById('ajax_collections_container');
					if(collections_container){
						var data = collections_container.getAttribute('x-init');
						if( data.startsWith( 'collections=' ) ){ 
							data = JSON.parse( data.substring( 12 ) );
							self.collections = self.collections.concat(data);
						} else {
							console.error( 'section/collections-list.liqud: ==>> #ajax_collections_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collections-list.liqud  ==>> #ajax_collections_container missing' );
					}
					console.log(self.collections);
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			}

		}));
	});

  } catch(e) { console.error(e); }
})();
      })();
